import styled from 'styled-components';

export const Background = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  color: #fff;
`;

export const AnubisContainer = styled.div`
  position: relative;

  img:hover {
    filter: brightness(80%);
  }

  a {
    position: absolute;
    top: 20px;
    left: 45px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #000;
    color: #fff;
    display: none;

    &:hover {
      background: #e315f2;
    }
  }

  &:hover {
    a {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
